(function () {
  'use strict';

  /* ── AJAX Load More ──
     Event delegation on document: the button is re-rendered from scratch
     every time category nav (wc-plp.js) or facet filters (facets.js)
     replace #ProductGridContainer's innerHTML, so a listener bound
     directly to the button would be lost on every AJAX swap. */
  function initLoadMore() {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-load-more]');
      if (btn) handleLoadMore(btn);
    });
  }

  function handleLoadMore(btn) {
    const nextUrl = btn.dataset.nextUrl;
    if (!nextUrl || btn.disabled) return;

    btn.disabled = true;
    btn.classList.add('wc-load-more__btn--loading');

    fetch(nextUrl)
      .then(function (res) {
        /* Sin este chequeo un 429/500 devolvía HTML de error que se parseaba
           sin [data-load-more], cayendo al else que hacía wrap.remove() y
           borraba el botón para siempre, truncando el catálogo. Lanzar aquí
           deja que el .catch reintente. */
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll('ul.product-grid .grid__item');
        const grid = document.querySelector('ul.product-grid');

        if (grid && newItems.length) {
          newItems.forEach(function (item) { grid.appendChild(item); });
        }

        const nextBtn = doc.querySelector('[data-load-more]');
        if (nextBtn && nextBtn.dataset.nextUrl) {
          btn.dataset.nextUrl = nextBtn.dataset.nextUrl;
          btn.disabled = false;
          btn.classList.remove('wc-load-more__btn--loading');
        } else {
          const wrap = btn.closest('.wc-load-more');
          if (wrap) wrap.remove();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('wc-load-more__btn--loading');
        showLoadMoreError(btn);
      });
  }

  /* Feedback en un fallo transitorio: sin esto el spinner desaparecía sin
     explicación y el usuario no sabía que no cargó nada. */
  function showLoadMoreError(btn) {
    const wrap = btn.closest('.wc-load-more');
    if (!wrap) return;
    let msg = wrap.querySelector('.wc-load-more__error');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'wc-load-more__error';
      msg.setAttribute('role', 'alert');
      wrap.appendChild(msg);
    }
    msg.textContent = 'No se pudo cargar. Intenta de nuevo.';
    clearTimeout(showLoadMoreError._t);
    showLoadMoreError._t = setTimeout(function () { msg.remove(); }, 5000);
  }

  /* ── Mobile Filter Drawer ── */
  function initMobileFilter() {
    const btn = document.querySelector('.wc-mob-filter-btn');
    const overlay = document.querySelector('.wc-mob-filter-overlay');
    const sidebar = document.querySelector('.wc-plp-sidebar');
    if (!btn || !sidebar) return;

    const label = btn.querySelector('.wc-mob-filter-btn__label');

    function openFilter() {
      sidebar.classList.add('is-open');
      if (overlay) overlay.classList.add('is-visible');
      btn.setAttribute('aria-expanded', 'true');
      if (label) label.textContent = btn.dataset.closeLabel || 'Cerrar filtros';
      document.body.style.overflow = 'hidden';
      /* El sheet solo es diálogo mientras está abierto; en desktop el mismo
         nodo es un sidebar estático y no debe llevar role=dialog */
      document.body.classList.add('wc-filter-open');
      sidebar.setAttribute('role', 'dialog');
      sidebar.setAttribute('aria-modal', 'true');
      sidebar.setAttribute('tabindex', '-1');
      const close = sidebar.querySelector('[data-wc-filter-close]');
      (close || sidebar).focus();
    }

    function closeFilter() {
      if (!sidebar.classList.contains('is-open')) return;
      sidebar.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-visible');
      btn.setAttribute('aria-expanded', 'false');
      if (label) label.textContent = btn.dataset.openLabel || 'Filtrar y ordenar';
      document.body.style.overflow = '';
      document.body.classList.remove('wc-filter-open');
      sidebar.removeAttribute('role');
      sidebar.removeAttribute('aria-modal');
      btn.focus();
    }

    btn.addEventListener('click', function () {
      sidebar.classList.contains('is-open') ? closeFilter() : openFilter();
    });

    if (overlay) overlay.addEventListener('click', closeFilter);

    /* Delegado (el contenido del sheet se re-renderiza por AJAX):
       X dentro del sheet + cerrar al navegar a una categoría */
    sidebar.addEventListener('click', function (e) {
      if (e.target.closest('[data-wc-filter-close]')) {
        closeFilter();
        return;
      }
      if (e.target.closest('a.wc-sidebar-cats__link')) closeFilter();
    });

    document.addEventListener('keydown', function (e) {
      if (!sidebar.classList.contains('is-open')) return;
      if (e.key === 'Escape') {
        closeFilter();
        return;
      }
      /* Focus trap mínimo del diálogo */
      if (e.key === 'Tab') {
        const focusables = sidebar.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
        );
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initLoadMore();
      initMobileFilter();
    });
  } else {
    initLoadMore();
    initMobileFilter();
  }
})();
